import { hasLocalStorage } from '@archetype-themes/utils/storage'

let recentlyViewedIds = []

if (hasLocalStorage()) {
  const recentIds = localStorage.getItem('recently-viewed')

  if (recentIds && typeof recentIds !== undefined) {
    recentlyViewedIds = JSON.parse(recentIds)
  }
}

class RecentlyViewed extends HTMLElement {
  constructor() {
    super()

    this.initialized = false
    this.sectionId = this.getAttribute('data-section-id')
    this.maxProducts = this.getAttribute('data-max-products')

    this.init()
  }

  addIdToRecentlyViewed(id) {
    if (!id) return

    // Remove current product if already in recently viewed array
    if (recentlyViewedIds.includes(id)) {
      recentlyViewedIds.splice(recentlyViewedIds.indexOf(id), 1)
    }

    // Add id to array
    recentlyViewedIds.unshift(id)

    if (hasLocalStorage()) {
      localStorage.setItem('recently-viewed', JSON.stringify(recentlyViewedIds))
    }
  }

  init() {
    // Add current product to recently viewed
    this.addIdToRecentlyViewed(this.dataset.productId)

    if (this.initialized) {
      return
    }

    this.initialized = true

    // Stop if no data
    if (!recentlyViewedIds.length) {
      this.classList.add('hide')
      return
    }

    this.outputContainer = this.querySelector(`#RecentlyViewed-${this.sectionId}`)
    const currentId = this.getAttribute('data-product-id')

    let url = `${window.Shopify.routes.root}search?view=recently-viewed&type=product&q=`

    let products = ''
    let i = 0
    recentlyViewedIds.forEach((val) => {
      // Skip current product
      if (val === currentId) {
        return
      }

      // Stop at max
      if (i >= this.maxProducts) {
        return
      }

      products += `id:${val} OR `
      i++
    })

    url = url + encodeURIComponent(products)

fetch(url)
  .then((response) => response.text())
  .then((text) => {
    const html = document.createElement('div');
    html.innerHTML = text;

    const gridProducts = html.querySelectorAll('.grid-product');
    const count = gridProducts.length;

    if (count > 0) {
      const results = html.querySelector('.product-grid');

      // 🟢 Remove 'scrollable-grid--small' class from 'product-grid'
      results.classList.remove('scrollable-grid--small');
      results.classList.remove('new-grid');
      
      results.classList.add('swiper', 'swiper__recently-viewed');

      // Create the swiper-wrapper div
      const swiperWrapper = document.createElement('div');
      swiperWrapper.classList.add('swiper-wrapper');

      // Wrap each '.grid-product' inside a new parent div with class 'grid-product-parent'
      gridProducts.forEach(product => {
        const parentDiv = document.createElement('div');
        parentDiv.classList.add('swiper-slide');
        parentDiv.appendChild(product);
        swiperWrapper.appendChild(parentDiv);
      });

      // Append swiper-wrapper inside product-grid
      results.appendChild(swiperWrapper);

      // 🟢 Add Swiper navigation and pagination elements
      const swiperNavPrev = document.createElement('div');
      swiperNavPrev.classList.add('swiper-button-prev');
      swiperNavPrev.innerHTML = `
        <svg class="flickity-button-icon-left" viewBox="0 0 100 100">
          <path
            d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
            class="arrow"
          ></path>
        </svg>      
      `; // Shopify Liquid

      const swiperNavNext = document.createElement('div');
      swiperNavNext.classList.add('swiper-button-next');
      swiperNavNext.innerHTML = `
        <svg class="flickity-button-icon-left" viewBox="0 0 100 100">
          <path
            d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
            class="arrow"
            transform="translate(100, 100) rotate(180)"
          ></path>
        </svg>
      `; // Shopify Liquid

      const swiperPagination = document.createElement('div');
      swiperPagination.classList.add('swiper-pagination', 'medium-up--hide');

      // Append navigation and pagination to results
      results.appendChild(swiperNavPrev);
      results.appendChild(swiperNavNext);
      results.appendChild(swiperPagination);
      
      this.outputContainer.append(results);

      // 🟢 Initialize Swiper after appending elements
      setTimeout(() => {
        if (document.querySelector(".swiper__recently-viewed")) {
          new Swiper(".swiper__recently-viewed", {
            loop: true,
            spaceBetween: 20,
            slidesPerView: 2,
            lazy: false,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            breakpoints: {
              640: {
                slidesPerView: 2, // On smaller screens, show 1 slide
              },
              768: {
                slidesPerView: 3, // On tablets, show 2 slides
              },
              1024: {
                slidesPerView: 4, // On larger screens, show 3 slides
                }
            },
          });
        } else {
          console.error("Swiper container not found: swiper__recently-viewed");
        }
      }, 100); // Delay ensures DOM update before initialization

      } else {
        this.classList.add('hide');
      }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  disconnectedCallback() {
    this.initialized = false
  }
}

customElements.define('recently-viewed', RecentlyViewed)

